import { InferGetStaticPropsType } from 'next';
import { getStaticProps } from '@/src/pages/knowledge/blog/[slug]';

import { KnowHowForm, InlineContactForm } from '@components';

type Post = InferGetStaticPropsType<typeof getStaticProps>['post'];

export const splitByInsertions = ({
  src,
  post,
  tags,
  pardotUrl,
}: {
  src: string;
  post: Post;
  tags: React.ComponentType | null;
  pardotUrl?: string | null;
}): (string | React.ComponentType)[] =>
  src
    .split('<!-- お役立ち資料フォーム -->')
    .flatMap((e, i, a) =>
      i < a.length - 1
        ? [
            e,
            () => (
              <KnowHowForm
                category={post.hnavi?.hnaviMainCategory || undefined}
              />
            ),
          ]
        : [e]
    )
    .flatMap((e) => (typeof e === 'string' ? insertTags(e, tags) : e))
    .flatMap((e) =>
      insertContactForm({
        src: e,
        category: post.hnavi?.hnaviMainCategory,
        pardotUrl,
      })
    );

const insertTags = (
  src: string,
  component: React.ComponentType | null
): (string | React.ComponentType)[] => {
  if (!component) {
    return [src];
  }
  const split = src.split(/<!-- 関連リンク[0-9]+ -->/);
  if (split.length === 1) {
    return [src];
  }
  return [
    split.slice(0, split.length - 1).join(''),
    component,
    split.slice(-1)[0],
  ];
};

const insertContactForm = <T,>({
  src,
  category,
  pardotUrl,
}: {
  src: T;
  category?: string | null;
  pardotUrl?: string | null;
}) => {
  if (typeof src !== 'string') {
    return [src];
  }

  return src
    .split('<!-- 相談フォーム -->')
    .flatMap((e, i, a) =>
      i < a.length - 1
        ? [
            e,
            () => (
              <InlineContactForm
                category={category || undefined}
                pardotUrl={pardotUrl}
              />
            ),
          ]
        : [e]
    );
};
